var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"draggableContainer",attrs:{"id":"draggable-container"}},[_c('div',{attrs:{"id":"draggable-header"},on:{"mousedown":_vm.dragMouseDown}},[_vm._t("header")],2),_vm._t("main")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }